import React, { useEffect, useState } from "react";
import { useRef } from "react";
import useHideShowDropDown from "../../helpers/hideshowdropdown";
import Button from "./Button";
import HidebuttonSvg from "./svg/HidebuttonSvg";
import { useSelector } from "react-redux";
import BulkCanvas from "./BulkCanvas";

const StatusBar = (props) => {
  const colAttr = useSelector((state) =>
    props?.columnDef?.length > 0 ? props?.columnDef : state.attributes.columns
  );

  const [attributes, setAttributes] = useState([]);
  const [attrdisabled, setAttrdisabled] = useState(true);
  const [checkedAttr, setCheckedAttr] = useState([]);
  const [displayCanvas, setDisplayCanvas] = useState(false);
  const attr = useRef(null);
  const {
    noHide,
    hidecolumn,
    showAttributeListDropDown,
    showattrdrop,
    hideattrdrop,
  } = props;
  useHideShowDropDown(attr, () => {
    hideattrdrop();
  });
  useEffect(() => {
    const attributefilter = colAttr.filter((item) => item.bulkupdate);
    setAttributes(attributefilter);
  }, [colAttr]);

  useEffect(() => {
    const newattr = attributes.filter((item) => item.isChecked);
    setCheckedAttr(newattr);
    const filcheck = attributes.filter((att) => att.isChecked === true);
    if (filcheck.length > 0) {
      setAttrdisabled(false);
    } else {
      setAttrdisabled(true);
    }
  }, [attributes]);
  // useEffect(() => {
  //   if (props.code === 200) {
  //     hideCanvas();
  //   }
  // }, [props]);
  const onChangeHandler = (event) => {
    const { name, checked } = event.target;
    const newmap = attributes.map((item) =>
      item.field === name ? { ...item, isChecked: checked } : item
    );
    const findind = attributes;
    setAttributes(newmap);
  };

  let attrmap;

  if (attributes.length > 0) {
    attrmap = (
      <ul>
        {attributes.map((attr, index) => {
          return (
            attr.attribute_type != "attachment" &&
            attr.attribute_type != "board" &&
            attr.attribute_type != "start_date" &&
            attr.attribute_type != "end_date" &&
            attr.attribute_type != "go_live_date" &&
            attr?.bulkupdate && (
              <li key={index}>
                <span className="attr_check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name={attr.field}
                    onChange={onChangeHandler}
                    checked={attr.isChecked || false}
                  />
                </span>
                <span className="attr_name">{attr.headerName}</span>
              </li>
            )
          );
        })}
      </ul>
    );
  } else {
    attrmap = <p>No attribute found for bulk action</p>;
  }

  const showbulkcanvas = () => {
    setDisplayCanvas(true);
  };
  const hideCanvas = () => {
    setDisplayCanvas(false);
  };
  const submitbulkValues = (data) => {
    const customertattleid = props.selectedrowsdata.map(
      (item) => item.customer_tattle_uuid || Number(item)
    );
    const bulkupdates = {
      attributes: { ...data },
      bulk_type: "customer_tattle_uuid",
      bulk_data: customertattleid,
    };
    props.submitBulkUpdate(bulkupdates);
    setDisplayCanvas(false);
  };
  return (
    <>
      {displayCanvas && (
        <BulkCanvas
          handleCloseFun={hideCanvas}
          displayCanvas={displayCanvas}
          checkattr={checkedAttr}
          submitbulkValues={submitbulkValues}
          tattle_id={props.customer_tattle_uuid}
          isBulkUpload={props.isBulkUpload}
          users={props.users}
        />
      )}
      {/* {(props.userType == 1 || props.child) && ( */}
      <div
        className={`grid-status-bar ${props.viewType ? props.viewType : ""} ${
          props?.padding && "no-padding"
        }`}
      >
        <div className="grid-status-title">
          <span className="status-bar-text">
            {noHide.length > 0 && props.selectedrowsdata.length > 0
              ? noHide.length +
                " column's and " +
                props.selectedrowsdata.length +
                ` ${props.type ? props.type : "row"} selected`
              : noHide.length > 0
              ? +noHide.length + " column's Selected"
              : props.selectedrowsdata.length > 0
              ? props.selectedrowsdata.length +
                ` ${props.type ? props.type : "row"} selected`
              : ""}
          </span>
        </div>
        <div className="right-section">
          <div className="hide-button">
            {props.noHide.length > 0 && (
              <button className="muBtn _blue" onClick={hidecolumn}>
                Hide
              </button>
            )}
          </div>
          <div className="bulk-update">
            {props.selectedrowsdata.length > 0 && (
              <>
                <button
                  className={`muBtn _gray btn-sm ${
                    props.className ? props.className : ""
                  }`}
                  onClick={props.clearBulkAction}
                >
                  Cancel
                </button>
                &nbsp;&nbsp;
                <button
                  className={`muBtn _blue btn-sm ${
                    props.className ? props.className : ""
                  }`}
                  onClick={showAttributeListDropDown}
                >
                  Bulk actions &nbsp;<i className="fa fa-chevron-down"></i>
                </button>
              </>
            )}
            {showattrdrop && (
              <div className="dropdown-attr" ref={attr}>
                <div className="main-attr">
                  <div className="list-attrs">{attrmap}</div>
                  <div className="attr_actions">
                    <Button
                      type="button"
                      text="Apply"
                      className="muBtn _blue"
                      disabled={attrdisabled}
                      onClick={showbulkcanvas}
                    />
                    <Button
                      type="button"
                      text="Cancel"
                      className="muBtn _danger border-none border-0"
                      onClick={hideattrdrop}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* // )} */}
    </>
  );
};

export default StatusBar;
